/**
 * Fairy Dust Farm Graph
 *
 * Complete graph definition for the fairy dust farm decision analysis.
 * Compares keeping the inherited farm vs selling and investing.
 */

import { GraphDefinition, Node } from '../../lib/computation-graph';
import { sources } from './sources';
import { assumptions } from './assumptions';
import { computedNodes } from './computed';

// Combine all nodes
const allNodes: Record<string, Node> = {
  ...sources,
  ...assumptions,
  ...computedNodes,
};

/**
 * The complete fairy dust farm graph definition
 */
export const fairyDustFarmGraph: GraphDefinition = {
  id: 'fairy-dust-farm',
  name: 'Fairy Dust Farm Analysis',
  description: 'Compare keeping inherited fairy dust farm vs selling and investing in magical markets',
  nodes: allNodes,
};

// Re-export individual modules for direct access
export { sources } from './sources';
export { assumptions } from './assumptions';
export { computedNodes } from './computed';

export default fairyDustFarmGraph;
